import Vue from "vue";
import VueI18n from "vue-i18n";
// import I18nTranslate from "../plugins/i18n-translate";

// Importer les messages de traduction
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";

Vue.use(VueI18n);

const messages = {
  en: en,
  fr: fr,
  es: es,
  it: it,
};

// Détection automatique de la langue du navigateur
function detectLocale() {
  const navLang = (
    navigator.language ||
    navigator.userLanguage ||
    "fr"
  ).toLowerCase();
  // ou param lang=fr
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get("lang");
  if (langParam && ["fr", "en", "es", "it"].includes(langParam.toLowerCase())) {
    console.log("Detected lang param:", langParam);
    return langParam.toLowerCase();
  }

  console.log("Detected browser language:", navLang);
  if (["fr", "en", "es", "it"].includes(navLang.substr(0, 2))) {
    return navLang.substr(0, 2);
  }
  return "en"; // fallback principal
}

const i18n = new VueI18n({
  locale: detectLocale(),
  fallbackLocale: ["fr", "en", "es", "it"],
  messages,
});

export default i18n;
// export const initI18nTranslate = (appName) => {
//   Vue.use(I18nTranslate, {
//     i18n,
//     appName: appName || "Sinao",
//     brand: "Sinao", // la source à remplacer
//   });
// };
